import React from 'react';

const Modal = ({ isOpen, onClose, title, message, type = 'info', onConfirm, confirmText = 'OK', cancelText = 'Cancel', showCancel = false }) => {
    if (!isOpen) return null;

    const getIcon = () => {
        switch (type) {
            case 'success': return '✅';
            case 'error': return '❌';
            case 'warning': return '⚠️';
            case 'confirm': return '❓';
            case 'loading': return '⏳';
            default: return 'ℹ️';
        }
    };

    const getColor = () => {
        switch (type) {
            case 'success': return '#1DB954';
            case 'error': return '#FF4B1F';
            case 'warning': return '#FF9068';
            case 'confirm': return '#2196F3';
            case 'loading': return '#FF9068';
            default: return '#666';
        }
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.85)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            backdropFilter: 'blur(4px)'
        }}>
            <div style={{
                background: '#1a1a1a',
                borderRadius: '16px',
                padding: '30px',
                maxWidth: '500px',
                width: '90%',
                border: `2px solid ${getColor()}`,
                boxShadow: '0 10px 40px rgba(0, 0, 0, 0.5)',
                animation: 'modalFadeIn 0.2s ease-out'
            }}>
                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <div style={{ fontSize: '3rem', marginBottom: '15px' }}>{getIcon()}</div>
                    {title && (
                        <h3 style={{ 
                            margin: '0 0 15px 0', 
                            color: getColor(),
                            fontSize: '1.3rem',
                            fontWeight: 'bold'
                        }}>
                            {title}
                        </h3>
                    )}
                    <p style={{ 
                        margin: 0, 
                        color: '#ccc', 
                        fontSize: '1rem',
                        lineHeight: '1.5',
                        whiteSpace: 'pre-line'
                    }}>
                        {message}
                    </p>
                </div>

                {type === 'loading' ? (
                    <div style={{ textAlign: 'center', padding: '10px' }}>
                        <div className="spinner" style={{ margin: '0 auto' }}></div>
                    </div>
                ) : (
                    <div style={{ 
                        display: 'flex', 
                        gap: '10px', 
                        justifyContent: 'center',
                        marginTop: '25px'
                    }}>
                        {showCancel && (
                            <button
                                onClick={onClose}
                                style={{
                                    padding: '12px 30px',
                                    background: '#333',
                                    border: '1px solid #555',
                                    borderRadius: '8px',
                                    color: '#fff',
                                    fontSize: '1rem',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s'
                                }}
                                onMouseOver={(e) => e.target.style.background = '#444'}
                                onMouseOut={(e) => e.target.style.background = '#333'}
                            >
                                {cancelText}
                            </button>
                        )}
                        <button
                            onClick={onConfirm || onClose}
                            style={{
                                padding: '12px 30px',
                                background: getColor(),
                                border: 'none',
                                borderRadius: '8px',
                                color: '#fff',
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                minWidth: '100px'
                            }}
                            onMouseOver={(e) => e.target.style.opacity = '0.9'}
                            onMouseOut={(e) => e.target.style.opacity = '1'}
                        >
                            {confirmText}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Modal;
